/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ControlImpersonateRequest
 */
export interface ControlImpersonateRequest {
    /**
     * 
     * @type {string}
     * @memberof ControlImpersonateRequest
     */
    staff_email: string;
}

/**
 * Check if a given object implements the ControlImpersonateRequest interface.
 */
export function instanceOfControlImpersonateRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "staff_email" in value;

    return isInstance;
}

export function ControlImpersonateRequestFromJSON(json: any): ControlImpersonateRequest {
    return ControlImpersonateRequestFromJSONTyped(json, false);
}

export function ControlImpersonateRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlImpersonateRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'staff_email': json['staff_email'],
    };
}

export function ControlImpersonateRequestToJSON(value?: ControlImpersonateRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'staff_email': value.staff_email,
    };
}

